import React, { useEffect, useState, useCallback, useRef, useReducer } from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import agent from "../../agent";
import parse from "html-react-parser"; // HTML 파싱을 위한 라이브러리

/** AI api를 사용해서 사용자가 입력한 문단을 분석하여 내용에 맞는 이미지를 생성합니다. */
const ImageGeneratorBoard = inject("commonStore")(
  observer((props) => {
    const [chatgptResponse, setChatgptResponse] = useState(""); // api에서 응답받은 chatgpt 결과 저장용
    const [chatgptResponses, setChatgptResponses] = useState([]); // api에서 응답받은 chatgpt 결과 저장용
    const [dalleResponse, setDalleResponse] = useState([]); // api에서 응답받은 이미지 데이터 저장용

    const [selectImages, setSelectImages] = useState([]); // 사용자가 선택한 이미지 값 저장용
    const [selectedImageIndices, setSelectedImageIndices] = useState({}); // 선택한 이미지의 상태 인덱스를 관리하기 위한 변수
    const [paragraphImageIndex, setParagraphImageIndex] = useState(null);
    const [selectedIndices, setSelectedIndices] = useState({});
    const [combinedParagraph, setCombinedParagraph] = useState({}); // 분리되어 있는 태그를 합쳐서 하나의 문단 chunk로 만들기 위함
    const [isGenerating, setIsGenerating] = useState(false); // 이미지 생성 함수 동작시, 화면에 상태를 출력하기 위함 - chatgpt용
    const [isGeneratingImage, setIsGeneratingImage] = useState(false); // 이미지 생성 함수 동작시, 화면에 상태를 출력하기 위함 - image api용
    const [isGeneratingerrorMessage, setIsGeneratingErrorMessage] = useState(null); // 생성 에러가 난 경우 출력하기 위함 - chatgpt용
    const [startImageAPI, setStartImageAPI] = useState(false); // 이미지 api 실행 체크용 스위치 변수
    const [imageMergeResult, setImageMergeResult] = useState(null);
    // 마지막으로 선택한 인덱스와 버튼 타입 저장
    const [lastSelectedIndex, setLastSelectedIndex] = useState(Array(dalleResponse.length).fill(null));
    const [lastSelectedType, setLastSelectedType] = useState(Array(dalleResponse.length).fill(null));

    // console.log("props.contValue", props.contValue); // 에디터에 입력하는 값을 key i/o가 있을때마다 가져옴

    // 생성한 이미지를 선택한 경우 해당 데이터를 부모에게 넘길 값에 추가하는 작업
    const imageSelector = async (index, buttonType) => {
      // console.log("입력받은 인덱스 : ", index);
      // console.log("선택한 버튼 buttonType :", buttonType);

      // 마지막으로 선택한 인덱스와 버튼 타입 저장
      setLastSelectedIndex((prev) => {
        const newArray = [...prev];
        newArray[Math.floor(index / 3)] = index;
        return newArray;
      });
      setLastSelectedType((prev) => {
        const newArray = [...prev];
        newArray[Math.floor(index / 3)] = buttonType;
        return newArray;
      });

      // +1을 추가해서 1-based index로 만듦
      // 한 문단당 총 3개의 이미지를 생성하므로 3으로 나눠서 계산한다.
      const paragraphIndex = Math.ceil((index + 1) / 3);

      const groupIndex = Math.floor(index / 3);
      setSelectedIndices((prev) => ({ ...prev, [groupIndex]: index }));

      // setParagraphImageIndex(paragraphIndex)
      console.log(paragraphIndex, "번째 문단의 이미지를 선택하셨습니다."); // 확인용 콘솔

      let imageMergeFileName = null;
      let paragraphSnippetForMerge = null;

      // 선택한 버튼이 filter이면 imagemerge 함수 실행
      if (buttonType === "filter") {
        // imageMergeFilter(dalleResponse[index].image_name, dalleResponse[index].paragraphSnippet);
        console.log("함수 안, imageMergeResult:", imageMergeResult);

        // 이미지 필터 기능 실행
        let punctuation = [".", "?", ",", "!"];

        for (let char of punctuation) {
          let indexForMerge = dalleResponse[index].paragraphSnippet.indexOf(char);
          if (indexForMerge !== -1) {
            paragraphSnippetForMerge = dalleResponse[index].paragraphSnippet.slice(0, indexForMerge + 1);
            break;
          }
        }

        console.log("합성할 문자 : ", paragraphSnippetForMerge);

        let imageMergeData = {
          image_name: dalleResponse[index].image_name.replace(".png", ""),
          text_on_image: paragraphSnippetForMerge,
        };

        try {
          // const res = await agent.Python_API.image_merge(imageMergeData);
          // // agent.Python_API.image_merge(imageMergeData)
          // // .then((res)=>{
          // console.log("merge 결과:",res)
          // console.log("이미지 합성 파일 이름", res.response)
          // imageMergeFileName = res.response
          // setImageMergeResult(res.response)
          // })
          let res = await agent.Python_API.image_merge(imageMergeData);
          if (res && res.response) {
            // console.log("merge 결과:", res);
            // console.log("이미지 합성 파일 이름", res.response);
            imageMergeFileName = res.response;
          } else {
            console.log("Something went wrong with image_merge function");
          }
        } catch (err) {
          console.error("There was an error with the image_merge call", err);
        }

        let selectedImage = {
          image_index: dalleResponse[index].index, // 이미지의 생성 번호(=순서)
          image_name: imageMergeFileName, // 저장한 이미지 파일명(uuid)
          // image_name: buttonType === "original" ? dalleResponse[index].image_name : imageMergeFileName, // 저장한 이미지 파일명(uuid)
          paragraphNumber: paragraphIndex, // 해당 이미지가 몇번째 문단에 대한 이미지인지
          paragraphSnippet: dalleResponse[index].paragraphSnippet, // 이미지를 문단 앞에 자동 추가하기 위한 스니펫
        };
        // console.log("selectedImage:", selectedImage); // 선택한 이미지 확인용

        setSelectImages((prevImages) => {
          // 이미 존재하는 paragraphNumber가 있는지 체크
          const existingIndex = prevImages.findIndex((item) => item.paragraphNumber === paragraphIndex);

          if (existingIndex === -1) {
            // 선택한 이미지가 없으면 새로운 값으로 추가
            return [...prevImages, selectedImage];
          } else {
            // 이미 선택한 이미지가 있으면 기존 값을 업데이트
            return prevImages.map((item, idx) => (idx === existingIndex ? selectedImage : item));
          }
        });
      } else {
        // console.log("dalleResponse[index].image_name::", dalleResponse[index].image_name);
        // console.log("imageMergeFileName::", imageMergeFileName);

        // 이미지의 paragraphNumber 값을 추가해서 부모 컴포넌트에 넘기기 위해 객체로 저장
        // image merge 함수가 완료되도록 비동기로 처리해야함

        let selectedImage = {
          image_index: dalleResponse[index].index, // 이미지의 생성 번호(=순서)
          image_name: dalleResponse[index].image_name, // 저장한 이미지 파일명(uuid)
          // image_name: buttonType === "original" ? dalleResponse[index].image_name : imageMergeFileName, // 저장한 이미지 파일명(uuid)
          paragraphNumber: paragraphIndex, // 해당 이미지가 몇번째 문단에 대한 이미지인지
          paragraphSnippet: dalleResponse[index].paragraphSnippet, // 이미지를 문단 앞에 자동 추가하기 위한 스니펫
        };
        // console.log("selectedImage:", selectedImage); // 선택한 이미지 확인용

        setSelectImages((prevImages) => {
          // 이미 존재하는 paragraphNumber가 있는지 체크
          const existingIndex = prevImages.findIndex((item) => item.paragraphNumber === paragraphIndex);

          if (existingIndex === -1) {
            // 선택한 이미지가 없으면 새로운 값으로 추가
            return [...prevImages, selectedImage];
          } else {
            // 이미 선택한 이미지가 있으면 기존 값을 업데이트
            return prevImages.map((item, idx) => (idx === existingIndex ? selectedImage : item));
          }
        });
      }
    };

    // state값 변경 확인용
    useEffect(() => {
      console.log("업데이트 된 selectImages:", selectImages);
    }, [selectImages]);

    useEffect(() => {
      console.log("dalleResponse:", dalleResponse);
    }, [dalleResponse]);

    // 셀렉트한 이미지 배열 가져와서 부모(ComposeTemplate)에게 넘기기
    const imageSelectHandler = (images) => {
      console.log("images:", images);

      if (dalleResponse && dalleResponse.length !== 0) {
        console.log("셀렉터 함수 dalleResponse :", dalleResponse);
        props.GeneratedImageHandler(dalleResponse);
      }
    };

    /** 이미지 생성을 위한 함수 (main) */
    const imageGenerator = (value) => {
      setIsGenerating(true);
      setIsGeneratingErrorMessage(null);

      // 나뉘어진 태그들을 합쳐서 하나의 스트링으로 만든 문단을 ai에게 넘겨야 함
      value.forEach((val, index) => {
        // let innerElements = val.props.children[0].props.children[1];
        let innerElements = val?.props?.children[0]?.props?.children[1]; // 값이 있는지 확인
        let combined = innerElements.map((innerEl) => innerEl.key).join(" ");

        setCombinedParagraph((prevState) => ({
          ...prevState,
          [index]: combined,
        }));
      });
    };

    // 분리한 문단 안의 문장을 합친 값을 순서대로 딕셔너리에 저장함
    useEffect(() => {
      console.log("combinedParagraph", combinedParagraph);

      // 응답이 null이면 자동으로 다시 실행하게 하는 로직 적용
      const fetchResponses = async () => {
        const chatGptResponses = [];
        setStartImageAPI(false);

        for (const prompt of Object.values(combinedParagraph)) {
          let response = null;
          while (!response) {
            response = await agent.Python_API.chatgpt_turbo({ prompt }); // 프롬프트 수정 필요
            // response = await agent.Python_API.chatgpt({ prompt });
            if (!response || response == null) {
              console.log(`Error with response, retrying: ${prompt}`);
            } else {
              chatGptResponses.push({
                response,
                paragraphSnippet: prompt.slice(0, 30),
              });
            }
          }
        }

        setChatgptResponse(chatGptResponses[0]?.response);
        setChatgptResponses(chatGptResponses);
        setIsGenerating(false);
      };

      fetchResponses().catch((err) => {
        console.log("err:", err);
        setIsGeneratingErrorMessage(err.message);
        // setIsGenerating(false);
        setStartImageAPI(true);
      });
    }, [combinedParagraph]);

    // chatgpt 응답이 완료되면 하나씩 이미지를 생성해서 뿌려주는 함수
    // 응답 결과를 하나씩 순회하며 하나씩 이미지 출력
    useEffect(() => {
      console.log("응답결과 chatGptResponses:", chatgptResponses);
      // console.log("이미지 생성을 시작합니다.");

      const generateImages = async () => {
        const imageResponses = [];

        for (const { response, paragraphSnippet } of chatgptResponses) {
          let dalleResponse = null;
          setIsGeneratingImage(true);
          while (!dalleResponse || !dalleResponse.image_response.length) {
            dalleResponse = await agent.Python_API.stablediffusion({ prompt: response.chatGPT_response });

            if (!dalleResponse || !dalleResponse.image_response.length) {
              console.error("Error: image_response array is empty. Retrying...");
            } else {
              // console.log("Response:", dalleResponse);
              // console.log("paragraphSnippet:", paragraphSnippet);
              imageResponses.push({ dalleResponse, paragraphSnippet });
            }
          }
        }

        setIsGeneratingImage(false);

        console.log("이미지 Responses:", imageResponses);
        const imageNames = imageResponses.flatMap(({ dalleResponse, paragraphSnippet }) =>
          dalleResponse.image_response.map((item, index) => ({
            index: index,
            image_name: item.image_name,
            paragraphSnippet: paragraphSnippet,
          }))
        );
        console.log(imageNames);
        setDalleResponse(imageNames);
      };

      generateImages()
        .catch((err) => {
          console.log("err:", err);
          setIsGeneratingErrorMessage(err.message);
          setIsGenerating(false);
          // setIsGeneratingImage(false);
        })
        .finally(() => {
          // console.log("최종 실행입니다.");
        });
    }, [chatgptResponse, chatgptResponses, startImageAPI]);

    /** 이미지 merge 실행용 함수 */
    const imageMergeFilter = (imageName, paragraphSnippet) => {
      // console.log(imageName)
      // console.log(paragraphSnippet)

      let punctuation = [".", "?", ",", "!"];

      for (let char of punctuation) {
        let index = paragraphSnippet.indexOf(char);
        if (index !== -1) {
          paragraphSnippet = paragraphSnippet.slice(0, index + 1);
          break;
        }
      }

      console.log("합성할 문자", paragraphSnippet);

      let imageMergeData = {
        image_name: imageName.replace(".png", ""),
        text_on_image: paragraphSnippet,
      };

      agent.Python_API.image_merge(imageMergeData)
        .then((res) => {
          console.log("merge 결과:", res);
          console.log(res.response);
          setImageMergeResult(res.response);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    /** 첫 문장 길이 및 마침부호 포함 여부 확인용 함수 */
    const checkForPunctuation = (group) => {
      const punctuation = [".", ",", "!", "?"]; // 검사할 특수 문자
      const warningMessage = "첫 문장의 30자 이내에 특수 문자 (.,!,?)가 포함되지 않았습니다."; // 경고 메시지

      for (const element of group) {
        const first30Chars = element.key.slice(0, 30);
        const containsPunctuation = first30Chars.split("").some((char) => punctuation.includes(char));
        if (!containsPunctuation) {
          return warningMessage; // 특수 문자를 찾지 못하면 경고 메시지를 반환합니다.
        }
      }
      return null; // 그렇지 않으면 null을 반환합니다.
    };

    ///////////// 사용자가 에디터에 입력한 값을 파싱해서 문단화하는 부분 /////////////
    const parser = new DOMParser(); // DOMParser 객체 생성
    const doc = parser.parseFromString(props.contValue, "text/html"); // props.contValue를 파싱하여 HTML 문서로 변환
    const tags = doc.querySelectorAll("p, h2, h3, h4"); // 칼럼 본문을 구성하는 텍스트 태그를 모두 포함

    let index = 0; // 인덱스 초기화: 각 문단 그룹을 구분하는 데 사용될 변수
    let group = []; // group 배열 : 현재 입력 중인 문단 그룹을 저장하는 배열
    const contValueElements = []; // elements 배열: 문단 그룹들을 저장하는 배열

    // 지정한 태그들을 반복하며 문단인지 검사
    // 문단의 기준 : 엔터
    Array.from(tags).forEach((tag) => {
      const innerHTML = tag.innerHTML.trim(); // 각 태그의 내용을 가져와서 양쪽 공백 제거

      // 태그의 내용이 비어 있거나 <br>인 경우
      if (innerHTML === "" || innerHTML === "<br>") {
        // 현재 진행 중인 문단 그룹에 내용이 있다면 (길이가 0이 아니라면)
        if (group.length > 0) {
          index++; // 인덱스를 증가시키고, 문단 그룹을 elements 배열에 추가함

          const currentGroup = group; // 현재 문단 그룹을 별도의 변수에 저장
          const currentGroupLength = currentGroup.reduce((acc, pTag) => acc + pTag.key.length, 0); // 각 p 태그의 key 값 (innerHTML)의 길이를 모두 합침

          contValueElements.push(
            <Tuple key={index}>
              <div className="separated_paragraph" style={currentGroupLength >= 3000 ? { backgroundColor: "#c94f47" } : {}}>
                <p>
                  <span>{index}.</span>
                </p>
                {currentGroup}
              </div>
              {currentGroupLength >= 3000 && (
                <p style={{ color: "#c94f47", fontSize: "14px" }}>
                  • 문단의 길이가 너무 길어 정상 작동이 어렵습니다. enter를 입력하여 문단을 나눠주세요. (3000자 이하)
                </p>
              )}
              {checkForPunctuation(currentGroup) && <p style={{ color: "#c94f47", fontSize: "14px" }}>{checkForPunctuation(currentGroup)}</p>}
            </Tuple>
          );

          group = []; // 문단 그룹을 초기화
        }
      } else {
        // 태그의 내용이 있으면, 이를 현재 진행 중인 문단 그룹에 추가함
        group.push(<p key={innerHTML}>{parse(innerHTML)}</p>);
      }
    });

    // 마지막 문단 그룹이 아직 elements 배열에 추가되지 않았다면 추가하는 작업
    if (group.length > 0) {
      index++;
      contValueElements.push(
        <Tuple key={index}>
          <div className="separated_paragraph">
            <p>
              <span>{index}.</span>
            </p>
          </div>
          {group}
        </Tuple>
      );
    }

    const requirementsDescriptions = ["• 첫 문장의 길이가 30자 이내여야하고, 마침부호(. , ? !)가 들어가야한다.", "• 문단의 총 길이는 3000자 이하여야 한다."];

    return (
      <>
        <ImageGeneratorContainer>
          <>
            <h1>이미지 생성기</h1>
            <p>문단 내용을 인식해서 이미지를 생성합니다.</p>
            <p>이미지 생성 후 본문의 내용을 수정하지 마세요.</p>
            <br />
            <h1>필요 조건</h1>
            {requirementsDescriptions.map((description, index) => (
              <div key={index}>
                <p>{description}</p>
              </div>
            ))}

            {/* 실제 사용할 값 */}
            <div className="input_preview_box" data-gramm="false" contentEditable={false}>
              {contValueElements}
            </div>

            {/* 현재 입력되어있는 문단을 기준으로 이미지 생성 */}
            <span className="image_generate_btn" onClick={() => imageGenerator(contValueElements)}>
              이미지 생성하기
            </span>

            {isGenerating ? <span> chatgpt 응답 생성 중..</span> : <></>}
            {isGeneratingImage ? <span> 이미지 생성 중..</span> : <></>}
            {/* {isGeneratingerrorMessage && <span>생성 실패: {isGeneratingerrorMessage}</span>} */}
            {isGeneratingerrorMessage && <span> 미생성</span>}

            {/* 선택한 이미지의 값들을 배열로 저장함 */}
            {selectImages && selectImages.length !== 0 ? (
              <span className="select_data_save_btn" onClick={() => props.GeneratedImageHandler(selectImages)}>
                선택한 이미지 저장
              </span>
            ) : (
              <></>
            )}

            <Tuple>
              <div className="created_images_container">
                <span className="file_name">file name</span>
                <span className="image_create_number">image create number</span>
                <span className="index">index</span>
                <span className="paragraph_snippet">paragraph snippet</span>
                <span className="preview">preivew</span>
                <span className="select_state">select state</span>
              </div>
            </Tuple>

            {/* api에서 응답받은 이미지를 화면에 출력 */}
            {dalleResponse && dalleResponse.length !== 0 ? (
              dalleResponse.map((item, index) => (
                <>
                  <Tuple>
                    <div className="created_images_container">
                      <span>{item.image_name}</span>
                      <span>{item.index}</span>
                      <span>{index}</span>
                      <Text>{item.paragraphSnippet}</Text>
                      <img
                        key={index}
                        src={`https://okr.luvd.co.kr/api/common/image/${item.image_name}`}
                        alt="Generated"
                        style={{ width: "80px", height: "auto" }}
                      />
                      <span
                        className="select_image"
                        onClick={() => imageSelector(index, "filter")}
                        style={
                          lastSelectedIndex[Math.floor(index / 3)] === index && lastSelectedType[Math.floor(index / 3)] === "filter"
                            ? { backgroundColor: "pink" }
                            : {}
                        }
                      >
                        필터선택
                      </span>
                      <span
                        className="select_image"
                        onClick={() => imageSelector(index, "original")}
                        style={
                          lastSelectedIndex[Math.floor(index / 3)] === index && lastSelectedType[Math.floor(index / 3)] === "original"
                            ? { backgroundColor: "skyblue" }
                            : {}
                        }
                      >
                        원본선택
                      </span>
                    </div>
                  </Tuple>
                </>
              ))
            ) : (
              <></>
            )}
            <div></div>
          </>
        </ImageGeneratorContainer>
      </>
    );
  })
);

const Text = styled.span`
  display: inline-block;
  width: 25ch; // 자를 글자 기준 너비
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  p,
  span {
    font-size: 13px;
    line-height: 17px;
  }
`;

const Tuple = styled.div`
  p,
  span {
    font-size: 13px;
    line-height: 17px;
  }

  .separated_paragraph {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #c8d9f7;
    margin-top: 10px;
  }

  .created_images_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  .select_image {
    border-radius: 8px;
    width: 100px;
    height: 30px;
    margin-top: 5px;
    background-color: lightgrey;
    text-align: center;
    line-height: 30px;
  }
`;

const ImageGeneratorContainer = styled.div`
  background: #ffffff;
  height: 350px;
  margin-top: 20px;
  padding: 20px;
  overflow: auto;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  box-sizing: border-box;

  h1 {
    font-size: 15px;
    font-weight: 700;
  }

  p,
  span {
    font-size: 13px;
    line-height: 17px;
  }

  .input_preview_box {
    border: 1px solid #e4e4e4;
    margin: 10px auto;
    box-sizing: border-box;
    padding: 15px;
    resize: none;
    overflow-y: auto;
  }

  .image_generate_btn {
    margin-left: 5px;
    border-radius: 4px;
    padding: 8px;
    display: inline-block;
    cursor: pointer;
    background-color: #42415c;
    color: white;
  }

  .select_data_save_btn {
    margin-left: 5px;
    border-radius: 4px;
    padding: 8px;
    display: inline-block;
    cursor: pointer;
    background-color: #698cc9;
    color: white;
  }

  .created_images_container {
    margin: 10px auto;
    border-radius: 4px;
    border: 1px solid #e4e4e4;
    box-sizing: border-box;
  }

  .api {
    border-radius: 8px;
    width: 120px;
    height: 30px;
    margin-top: 5px;
    background-color: pink;
    text-align: center;
    line-height: 30px;
  }
`;

export default ImageGeneratorBoard;
